/**
 * Camino Design System Typography
 * Source: TypographyDesignSystem.pdf
 *
 * Font: Lato
 * Weights: Regular (400), Medium (500), Bold (700)
 */

/**
 * Font weights
 */
export const fontWeights = {
  regular: 400,
  medium: 500,
  bold: 700,
} as const;

/**
 * Font sizes in pixels
 */
export const fontSizes = {
  xs: "10px",
  sm: "12px", // Text S (Standard)
  md: "14px",
  lg: "16px",
  xl: "20px",
  "2xl": "24px",
} as const;

/**
 * Text styles for Chakra UI
 * Usage: <Text textStyle="headerL">Large Header</Text>
 */
export const caminoTextStyles = {
  // Headers - Lato Bold
  headerL: {
    fontSize: "24px",
    fontWeight: 700,
    fontFamily: "Lato, sans-serif",
  },
  headerM: {
    fontSize: "20px",
    fontWeight: 700,
    fontFamily: "Lato, sans-serif",
  },
  headerS: {
    fontSize: "16px",
    fontWeight: 700,
    fontFamily: "Lato, sans-serif",
  },

  // Subtitles - Lato Medium
  subtitleL: {
    fontSize: "20px",
    fontWeight: 500,
    fontFamily: "Lato, sans-serif",
  },
  subtitleM: {
    fontSize: "16px",
    fontWeight: 500,
    fontFamily: "Lato, sans-serif",
  },
  subtitleS: {
    fontSize: "14px",
    fontWeight: 500,
    fontFamily: "Lato, sans-serif",
  },

  // Text - Lato Regular
  textL: {
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "Lato, sans-serif",
  },
  textM: {
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "Lato, sans-serif",
  },
  textS: {
    fontSize: "12px",
    fontWeight: 400,
    fontFamily: "Lato, sans-serif",
  },
  textXS: {
    fontSize: "10px",
    fontWeight: 400,
    fontFamily: "Lato, sans-serif",
  },
} as const;

export type FontWeights = typeof fontWeights;
export type FontSizes = typeof fontSizes;
export type CaminoTextStyles = typeof caminoTextStyles;

export default caminoTextStyles;
